// Copyright (c) Docugami, Inc. All rights reserved.

export enum ActionId {
    None = 'None',
    Select = 'Select',
    Deselect = 'Deselect',
    SelectCursor = 'SelectCursor'
}

export enum ActionType {
    Button,
    Axis2d
}

/**
 * The base action class. Actions are used to abstract UX interactions from the input type
 * that triggers them.
 */
export interface Action {
    readonly actionType: ActionType;
    readonly actionId: ActionId;
}

export interface ButtonState {
    isDown: boolean;
    isUp: boolean;
    isPressed: boolean;
    handled: boolean;
    handle: () => void;
}

export function createButtonState(handled: boolean, handle: () => void) {
    return {
        isDown: false,
        isUp: false,
        isPressed: false,
        handled: handled,
        handle: handle
    }
}

/**
 * Simple button action
 */
export interface ButtonAction extends Action {
    readonly actionType: ActionType.Button;
    isDown: boolean,
    isUp: boolean,
    isPressed: boolean
}

export function createButtonAction(actionId: ActionId): ButtonAction {
    return {
        actionType: ActionType.Button,
        actionId: actionId,
        isDown: false,
        isUp: false,
        isPressed: false
    }
}

/**
 * Simple 2D axis action
 */
export interface Axis2dAction extends Action {
    x: number;
    y: number;
    valid: boolean;
}

export function createAxis2dAction(actionId: ActionId): Axis2dAction {
    return {
        actionType: ActionType.Button,
        actionId: actionId,
        x: 0,
        y: 0,
        valid: false
    }
}
